import React from "react";
import { Friendslist } from "../Components/Friendslist";
import { Main } from "../Components/Main";

export const Home = () => {
	return <>
		<Friendslist />
		<Main />
	</>;
}